export default __webpack_public_path__ + "static/media/purification2.5006cd7b.png";